var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid2 as Grid, Typography, } from '@mui/material';
import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { EntidadeAnalise } from '../../enums/analise.enum';
import { getDisabledFlags } from '../../util/analise.utils';
import { isValidCpf } from '../../util/is-valid-cpf.util';
import { AnaliseGrupoStatusComponent } from '../Analise/AnaliseGrupoStatusComponent';
import MaskedTextFieldControl from '../Form/MaskedTextFieldControl';
import TextFieldControl from '../Form/TextFieldControl';
var operadorSchema = z.object({
    nome: z
        .string()
        .min(1, 'Nome é obrigatório')
        .max(100, 'Tamanho máximo excedido.'),
    cpf: z
        .string()
        .length(14, 'CPF inválido')
        .min(1, 'CPF inválido')
        .regex(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)
        .refine(function (cpf) { return isValidCpf(cpf); }, {
        message: 'CPF informado é inválido',
    }),
});
var DEFAULT_VALUES = {
    nome: '',
    cpf: '',
};
export var OperadorModalForm = function (_a) {
    var open = _a.open, operador = _a.operador, analise = _a.analise, modo = _a.modo, onClose = _a.onClose, onSave = _a.onSave;
    var _b = useForm({
        resolver: zodResolver(operadorSchema),
        defaultValues: operador !== null && operador !== void 0 ? operador : DEFAULT_VALUES,
    }), control = _b.control, handleSubmit = _b.handleSubmit;
    var disabled = useMemo(function () { return modo === 'visualizar'; }, [modo]);
    var disabledDadosGerais = getDisabledFlags(EntidadeAnalise.OPERADOR, operador === null || operador === void 0 ? void 0 : operador.id, analise === null || analise === void 0 ? void 0 : analise.gruposCampos, disabled).disabledDadosGerais;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var operadorData;
        return __generator(this, function (_a) {
            try {
                operadorData = __assign({}, data);
                if (onSave) {
                    onSave(operadorData);
                }
                else {
                    onClose();
                }
            }
            catch (error) {
                console.error('Erro ao adicionar operador:', error);
            }
            return [2 /*return*/];
        });
    }); };
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: "lg", children: [_jsx(DialogTitle, { children: modo === 'adicionar'
                    ? 'Adicionar Operador'
                    : modo === 'editar'
                        ? 'Editar Operador'
                        : 'Visualizar Operador' }), _jsxs(DialogContent, { children: [_jsx(Typography, { variant: "h6", children: "Informa\u00E7\u00F5es B\u00E1sicas" }), _jsx(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, children: _jsx(AnaliseGrupoStatusComponent, { analise: analise, entidade: "OPERADOR", grupo: "DADOS_GERAIS", entidadeAssociadaId: operador === null || operador === void 0 ? void 0 : operador.id, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "nome", label: "Nome", control: control, required: true, maxLength: 100, disabled: disabledDadosGerais }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(MaskedTextFieldControl, { name: "cpf", label: "CPF", control: control, mask: "000.000.000-00", required: true, disabled: disabledDadosGerais }) })] }) }) })] }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, children: "Cancelar" }), !disabledDadosGerais && (_jsx(Button, { variant: "contained", color: "primary", type: "submit", onClick: handleSubmit(onSubmit), children: "Salvar" }))] })] }));
};
